import { h, Component } from 'preact';

import style from '../../style/header.sass';

export default class HeaderImage extends Component {
  render(props) {
    if(!props.brand){
      return null;
    }
    let src = null;
    if(props.brand === 'rheem'){
      src = 'assets/images/rheem/rheem-pro-partner-logo.svg';
    }else if(props.brand === 'ruud'){
      src = 'assets/images/ruud/ruud-pro-partner-logo.png';
    }else if(props.brand === 'friedrich'){
      src = 'assets/images/friedrich/friedrich-pro-partner-logo.png';
    }
    return (
      <img className={style.logo} src={src} />
    );
  }
}